import { v4 as uuidv4 } from 'uuid';

import { RESULT_CODE } from '@/api/result_code';
import { useLoader } from '@/hooks/use_loader';
import { useState } from '@/hooks/use_state';
import { ActionBase } from '@/models/action_base';
import RouterConst from '@/router/router_const';
import { KbnConst } from '@/utils/kbn';

import { useActionDataClear } from './use_action_data_clear';
import { useApi } from './use_api';
import { useFileUpload } from './use_file_upload';
import { useInsertDataStore } from './use_insert_data_store';
import { useRouting } from './use_routing';
import { useSurvey } from './use_survey';
export class ActionReceiptUpload extends ActionBase {
  typeKbn = KbnConst.ACTION_TYPE_KBN_RECEIPT_UPLOAD;

  use() {
    const insertDataStore = useInsertDataStore();
    const survey = useSurvey();
    const routing = useRouting();
    const actionDataClear = useActionDataClear();
    const state = useState();
    return async () => await execute(
      insertDataStore,
      survey,
      routing,
      actionDataClear,
      state,
    );

  }

  constructor(init: Partial<ActionReceiptUpload> = {}) {
    super();
    Object.assign(this, init);
  }
}

export async function execute(
  insertDataStore: ReturnType<typeof useInsertDataStore>,
  survey: ReturnType<typeof useSurvey>,
  routing: ReturnType<typeof useRouting>,
  actionDataClear: ReturnType<typeof useActionDataClear>,
  state:  ReturnType<typeof useState>,
) {
  const loader = useLoader();
  const api = useApi();
  const { fileCache } = useFileUpload();

  if (!fileCache.value) return true; // ファイルが無い場合はアクション中断
  // surveyデータがあれば追加
  const surveyData = survey.getPostData();
  if (surveyData) {
    insertDataStore.survey.value = surveyData;
  }
  loader.start();
  try {

    //XShare突合用
    const xUuid = uuidv4();
    state.value.xUuid = xUuid;

    const { presignedUrl, receiptUuid } = (await api.getReceiptUploadUrl()).dataJson;
    await api.uploadFile(presignedUrl, fileCache.value, { 'x-amz-acl': 'public-read' });
    insertDataStore.route.value = state.value.route;
    insertDataStore.query.value = state.value.query;
    insertDataStore.id.value = state.value.id;
    insertDataStore.store.value = state.value.store;
    insertDataStore.shipping.value = state.value.shipping;
    insertDataStore.xUuid.value = state.value.xUuid;
    insertDataStore.course.value = state.value.course;

    const response = await api.postReceipt(receiptUuid, {
      ...insertDataStore.getValues(),
    });

    // アンケートのバリデーションエラーの場合、エラーページに遷移させる
    if (response.resultCode === RESULT_CODE.SURVEY_EMPTY_ANSWER
      || response.resultCode === RESULT_CODE.DUPLICATED_FIRST_ANSWERED_SURVEY
      || response.resultCode === RESULT_CODE.SURVEY_EMPTY_REQUIRED_FIELD
      || response.resultCode === RESULT_CODE.SURVEY_EMPTY_ANSWER
    ) {
      await routing.redirect(RouterConst.Error);
      fileCache.value = undefined;
      return true;
    }

    // データクリア
    await actionDataClear();

    // 返信グループに落ちなかった場合エラーページに遷移
    fileCache.value = undefined;

    // 現在のページで完了ページ切り分け
    if (routing.isNationalPath()) {
      await routing.redirect(RouterConst.NationalComplete);
    } else {
      await routing.redirect(RouterConst.TieUpComplete);
    }

    return false;

    // receiptUuid.value = null;
  } finally {
    loader.stop();
  }

}
